/** Build absolute URL for a stored path like `Images/admission/file.jpg`. */
export function admissionAssetUrl(apiBase, storedPath) {
    if (!storedPath) return "";
    const base = String(apiBase || "").replace(/\/+$/, "");
    const p = String(storedPath).replace(/^\/+/, "");
    return `${base}/${p}`;
}

function buildAdmissionFilesFormData(studentFile, aadharFile) {
    const fd = new FormData();
    if (studentFile) fd.append("studentImage", studentFile);
    if (aadharFile) fd.append("aadharImage", aadharFile);
    return fd;
}

function fileToDataUrl(file) {
    return new Promise((resolve, reject) => {
        const r = new FileReader();
        r.onload = () => resolve(r.result);
        r.onerror = () => reject(new Error("Could not read file"));
        r.readAsDataURL(file);
    });
}

/**
 * POST files to `/admission/documents` or `/admission/upload-documents`.
 * Returns `{ studentImage?, aadharImage? }`, or `null` if both URLs return 404 (server without upload routes).
 */
export async function uploadAdmissionDocuments(apiBase, token, { studentFile, aadharFile }) {
    if (!studentFile && !aadharFile) return {};
    const base = String(apiBase || "").replace(/\/+$/, "");
    const urls = [`${base}/admission/documents`, `${base}/admission/upload-documents`];

    for (const url of urls) {
        const fd = buildAdmissionFilesFormData(studentFile, aadharFile);
        const res = await fetch(url, {
            method: "POST",
            headers: {
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
            body: fd,
        });
        if (res.status === 404) continue;
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
            throw new Error(data.message || data.error || "Document upload failed");
        }
        const out = {};
        if (data.studentImage) out.studentImage = data.studentImage;
        if (data.aadharImage) out.aadharImage = data.aadharImage;
        return out;
    }
    return null;
}

/**
 * Prefer multipart upload; if the API has no upload route (404), embed files as data URLs
 * for the same JSON create/update payload (`studentImageDataUrl` / `aadharImageDataUrl`).
 */
export async function resolveAdmissionDocumentsForSave(apiBase, token, { studentFile, aadharFile }) {
    if (!studentFile && !aadharFile) return {};
    const uploaded = await uploadAdmissionDocuments(apiBase, token, { studentFile, aadharFile });
    if (uploaded !== null) return uploaded;

    const out = {};
    if (studentFile) {
        out.studentImageDataUrl = await fileToDataUrl(studentFile);
    }
    if (aadharFile) {
        out.aadharImageDataUrl = await fileToDataUrl(aadharFile);
    }
    return out;
}

export function isPdfPath(storedPath) {
    return /\.pdf$/i.test(String(storedPath || ""));
}
